import { customAlphabet } from 'nanoid';

const alphanumeric =
  'ModuleSymbhasOwnPr0123456789ABCDEFGHNRVfgctiUvzKqYTJkLxpZXIjQW';

export const randomId = (length = 21) => {
  const nanoid = customAlphabet(alphanumeric, length);
  return nanoid();
};